import React from 'react';
import Button from 'relements/build/esm/ui/button';
import Icon from '@src/components/Icon';
import { isProduction } from '@src/utils';
import styles from './PromptTriggerEditView.scss';

function AddPromptRule({ onClick, text = '', isTask = false }) {
  return (
    <>
      <div
        className={isTask ? styles.taskVariantTitle : styles.promptVariantTitle}
      >
        {text}
      </div>
      <div className={styles.promptVariantAdd}>
        <Button
          size={Button.SIZES.SMALL}
          onClick={onClick}
          disabled={isProduction()}
        >
          <Icon iconType="plus" /> Add New Rule <div />
        </Button>
      </div>
    </>
  );
}

export default AddPromptRule;
